export const Z = {
  MODAL_BACKDROP: 70,
  MODAL_CONTENT: 71,
  CONFIRM_DIALOG: 10000,
  TOAST: 9999,
} as const;
